<template>
    <div class="scc-drawing-result">
        <p v-if="text" class="scc-drawing-result__text">{{ text }}</p>
        <template v-if="pastDrawingWinners && pastDrawingWinners.length > 0">
            <p class="scc-drawing-result__title h5">{{ pastDrawingWinners.length }} winnaars!</p>
            <div class="scc-drawing-result__result-list">
                <template v-for="(result, i) in paginatedData">
                    <div
                        :key="i"
                        class="scc-drawing-result__result"
                        :class="[
                            result.ticketCode === pastDrawingWinners[0].ticketCode
                                ? 'scc-drawing-result__result--first'
                                : null,
                        ]"
                    >
                        <div class="scc-drawing-result__result-number-container">
                            <div class="scc-drawing-result__result-icon"></div>
                            <p class="scc-drawing-result__result-number bold">{{ result.ticketCode }}</p>
                        </div>
                        <p class="scc-drawing-result__result-prize">{{ result.prizeReference }}</p>
                    </div>
                </template>
            </div>
            <Pagination
                :totalPages="pageCount"
                :total="pastDrawingWinners.length"
                :currentPage="pageNumber"
                :perPage="limit"
                @pagechanged="onPageChange"
            />
            <p v-if="textBottom" class="scc-drawing-result__text-bottom">
                {{ textBottom }}
            </p>
        </template>
        <template v-else>
            <p class="scc-drawing-result__title h5">{{ noWinnersText }}</p>
        </template>
    </div>
</template>

<script>
import './drawing-result.scss';
import Pagination from './Pagination';

export default {
    name: 'DrawingResult',
    components: { Pagination },
    __editor: {
        requiredData: ['drawings'],
    },
    props: {
        drawings: {
            type: Array,
            required: true,
        },
        text: {
            type: String,
            default: '',
        },
        textBottom: {
            type: String,
            default: '',
        },
        limit: {
            type: Number,
            default: 12,
        },
        noWinnersText: {
            type: String,
            default: 'Er zijn nog geen winnaars bekend',
        },
    },
    data() {
        return {
            pageNumber: 1,
        };
    },
    computed: {
        pastDrawing() {
            const allDrawings = [...this.drawings];
            let publishedDrawings = allDrawings.filter(drawing => {
                return drawing.status && drawing.status === 'published';
            });
            let orderedDrawings = publishedDrawings.sort((a, b) => {
                return new Date(b.publishAt) - new Date(a.publishAt);
            });
            return orderedDrawings.find(drawing => {
                return new Date(drawing.publishAt) < new Date();
            });
        },
        pastDrawingWinners() {
            return this.pastDrawing && this.pastDrawing.winningTickets;
        },
        pageCount() {
            return Math.ceil(this.pastDrawingWinners.length / this.limit);
        },
        paginatedData() {
            const start = (this.pageNumber - 1) * this.limit,
                end = start + this.limit;
            return this.pastDrawingWinners.slice(start, end);
        },
    },
    methods: {
        onPageChange(page) {
            this.pageNumber = page;
        },
    },
};
</script>
